const mixpanel = require('mixpanel-browser');
export const track = mixpanel.track;
export default mixpanel;
